// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no_result[data-v-bf795cae] {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.center_box[data-v-bf795cae] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.icon-pub[data-v-bf795cae] {\n  color: #5E5F72;\n}\n.text_sty[data-v-bf795cae] {\n  color: #5E5F72;\n  font-weight: bold;\n  margin-top: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
